//# sourceMappingURL=admin.mjs.map
/// <reference types="./admin.d.mts" />
import * as $ds from "../ds/ds.mjs";
import * as $redraw from "../redraw/redraw.mjs";
import * as $compose from "../redraw_batteries/redraw/batteries/compose.mjs";
import * as $client from "../redraw_dom/redraw/dom/client.mjs";
import * as $lustre from "../redraw_lustre/redraw/lustre.mjs";
import * as $toastify from "../redraw_toastify/toastify.mjs";
import * as $init from "./admin/init.mjs";
import * as $update from "./admin/update.mjs";
import * as $store from "./data/store.mjs";
import { Ok, toList, makeError } from "./gleam.mjs";
import * as $layout from "./view/layout.mjs";
import * as $login from "./view/login.mjs";

const FILEPATH = "src/admin.gleam";

function view() {
  return $redraw.compose(
    $login.view(),
    (login) => {
      return $redraw.compose(
        $layout.view(),
        (layout) => {
          return $redraw.component_(
            "App",
            (_) => {
              let store = $store.use_state();
              let $ = $store.is_connected(store);
              if ($) {
                return layout(undefined);
              } else {
                return login(undefined);
              }
            },
          );
        },
      );
    },
  );
}

function scaffold(store) {
  return $redraw.compose(
    $ds.init(),
    (freyja) => {
      return $redraw.compose(
        $lustre.provider(),
        (provider) => {
          return $compose.static$(
            view(),
            (view) => {
              return $redraw.component_(
                "Scaffold",
                (_) => {
                  return provider(
                    new $lustre.Props(store, toList([freyja(toList([view()]))])),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function init_store() {
  let $ = $init.flags();
  let flags;
  if ($ instanceof Ok) {
    flags = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "admin",
      36,
      "init_store",
      "Pattern match failed, no pattern matched the value.",
      { value: $, start: 750, end: 785, pattern_start: 761, pattern_end: 770 }
    )
  }
  let initialization = $init.init(flags);
  return $lustre.store(initialization, $update.update);
}

export function main() {
  let store = init_store();
  let $ = $client.create_root("app");
  let root;
  if ($ instanceof Ok) {
    root = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "admin",
      15,
      "main",
      "Pattern match failed, no pattern matched the value.",
      { value: $, start: 257, end: 304, pattern_start: 268, pattern_end: 276 }
    )
  }
  return $client.render_(
    root,
    scaffold(store),
    (scaffold) => {
      return $redraw.strict_mode(
        toList([
          scaffold(undefined),
          $toastify.toast_container($toastify.props()),
        ]),
      );
    },
  );
}
